import {
  BedDoubleIcon,
  Building2Icon,
  HouseIcon,
  SprayCanIcon,
  StoreIcon,
  UtensilsCrossedIcon,
  WarehouseIcon,
  WashingMachineIcon,
} from "lucide-react";

export const services = [
  {
    id: "hotel-housekeeping",
    icon: BedDoubleIcon,
    name: { en: "Hotel Housekeeping", es: "Limpieza de Hoteles" },
    description: { en: "Professional hotel room cleaning and maintenance. Clean, professional, dependable service for every turnover.", es: "Limpieza y mantenimiento profesional de habitaciones de hotel. Servicio limpio, profesional y confiable en cada cambio." },
  },
  {
    id: "office-cleaning",
    icon: Building2Icon,
    name: { en: "Office Cleaning", es: "Limpieza de Oficinas" },
    description: { en: "Corporate office cleaning and facility care. Comprehensive solutions that keep your workplace sharp.", es: "Limpieza de oficinas corporativas y cuidado de instalaciones. Soluciones integrales para un lugar de trabajo impecable." },
  },
  {
    id: "apartment-cleaning",
    icon: HouseIcon,
    name: { en: "Apartment Cleaning", es: "Limpieza de Apartamentos" },
    description: { en: "Residential apartment and multi-family cleaning, including move-in and move-out turnovers.", es: "Limpieza de apartamentos y edificios multifamiliares, incluyendo mudanzas de entrada y salida." },
  },
  {
    id: "store-cleaning",
    icon: StoreIcon,
    name: { en: "Store Cleaning", es: "Limpieza de Tiendas" },
    description: { en: "Retail and commercial store cleaning for a pristine appearance your customers notice.", es: "Limpieza de tiendas y locales comerciales para una apariencia impecable que sus clientes notan." },
  },
  {
    id: "janitorial",
    icon: SprayCanIcon,
    name: { en: "Janitorial Services", es: "Servicios de Conserjería" },
    description: { en: "Full janitorial support and facility maintenance — daily, weekly or on demand.", es: "Conserjería completa y mantenimiento de instalaciones — diario, semanal o bajo demanda." },
  },
  {
    id: "kitchen-dishwasher",
    icon: UtensilsCrossedIcon,
    name: { en: "Kitchen & Dishwasher", es: "Cocina y Lavaplatos" },
    description: { en: "Professional kitchen cleaning and dishwashing staff for restaurants, hotels and cafeterias.", es: "Limpieza profesional de cocinas y lavaplatos para restaurantes, hoteles y cafeterías." },
  },
  {
    id: "laundry",
    icon: WashingMachineIcon,
    name: { en: "Laundry Staff", es: "Personal de Lavandería" },
    description: { en: "Professional laundry teams for hotels, facilities and commercial operations.", es: "Equipos de lavandería profesional para hoteles, instalaciones y operaciones comerciales." },
  },
  {
    id: "warehouse",
    icon: WarehouseIcon,
    name: { en: "Warehouse Support", es: "Apoyo en Almacenes" },
    description: { en: "Warehouse cleaning and support staff to keep aisles clear and operations moving.", es: "Limpieza de almacenes y personal de apoyo para mantener pasillos despejados y la operación en marcha." },
  },
];

export const serviceTypeById: Record<string, "cleaning" | "staffing" | "hospitality" | "custom"> = {
  "hotel-housekeeping": "hospitality",
  "office-cleaning": "cleaning",
  "apartment-cleaning": "cleaning",
  "store-cleaning": "cleaning",
  janitorial: "cleaning",
  "kitchen-dishwasher": "hospitality",
  laundry: "hospitality",
  warehouse: "staffing",
};

export const extraServices = [
  { en: "Staffing Solutions", es: "Soluciones de Personal" },
  { en: "Maintenance Support", es: "Apoyo de Mantenimiento" },
  { en: "Custom Solutions", es: "Soluciones a Medida" },
];
